import {
    FA_WEALTH,
    MA_WEALTH,
} from '../__constants__';
import * as analytics from '../analytics';
import {genderOptions} from "../components/FormComponents/SearchFilters";


const getGenderLabel = (gender) => {
    const option = genderOptions.find(ele => ele.value === gender);

    if (option === undefined) {
        return '';
    }

    return option.label
}
export function searchFiltersGTM(item, filterData, isMortgageAdviser) {
    if (item === 'wealth') {
        let data = isMortgageAdviser ? MA_WEALTH : FA_WEALTH;
        let gaLabel = '';

        Object.entries(data).forEach(obj => {
            const values = obj[1];

            if (values['ID'] === filterData.wealth && values.GA_LABEL) {
                gaLabel  = values.GA_LABEL;
            }
        });

        if (gaLabel) {
            return analytics.track('Wealth Criteria', {
                category: 'Filters',
                label: gaLabel
            });
        }

        return null;
    }

    if (item === 'search_range') {
        return analytics.track('Distance', {
            category: 'Filters',
        });
    }

    if (item === 'parentList' && filterData.type === 5) {
        return analytics.track('Services', {
            category: 'Filters',
            label: filterData.parentList.toString(),
        });
    }

    if (item === 'servicesList' && filterData.type !== 5) {
        return analytics.track('Services', {
            category: 'Filters',
            label: filterData.servicesList.toString(),
        });
    }

    if (item === 'gender') {
        return analytics.track('Gender', {
            category: 'Filters',
            label: getGenderLabel(filterData.gender),
        });
    }
}

export function searchFiltersCheckboxGTM(filter, checked) {
    if (filter === 'type_filter' && checked) {
        return analytics.track('Independent Only', {
            category: 'Filters',
        });
    }

    if (filter === 'advanced_qualifications' && checked) {
        return analytics.track('Advanced Qualification', {
            category: 'Filters',
        });
    }

    if (filter === 'fixed_fees' && checked) {
        return analytics.track('Fixed fee only', {
            category: 'Filters',
        });
    }
}
